"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _base = babelHelpers.interopRequireDefault(require("card/base"));

var _class, _descriptor, _class2, _temp;

var Types = {};
var CustomCatalogCard = (_class = (_temp = _class2 =
/*#__PURE__*/
function (_Card) {
  babelHelpers.inherits(CustomCatalogCard, _Card);

  function CustomCatalogCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CustomCatalogCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CustomCatalogCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "card_type", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(CustomCatalogCard, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(CustomCatalogCard.getSubType(this.card_type), this.props);
    }
  }], [{
    key: "getSubType",
    value: function getSubType(type) {
      if (!this.SubTypes[type]) {
        var _class3, _descriptor2, _descriptor3, _temp2;

        this.SubTypes[type] = (_class3 = (_temp2 =
        /*#__PURE__*/
        function (_require$default) {
          babelHelpers.inherits(CustomCard, _require$default);

          function CustomCard() {
            var _babelHelpers$getProt2;

            var _this2;

            babelHelpers.classCallCheck(this, CustomCard);

            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(CustomCard)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
            babelHelpers.initializerDefineProperty(_this2, "customCard", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
            babelHelpers.initializerDefineProperty(_this2, "customCardBody", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
            return _this2;
          }

          babelHelpers.createClass(CustomCard, [{
            key: "renderTileBody",
            value: function renderTileBody() {
              if (this.customCard) return _react.default.createElement("div", {
                dangerouslySetInnerHTML: {
                  __html: this.customCardBody
                }
              });
              return babelHelpers.get(babelHelpers.getPrototypeOf(CustomCard.prototype), "renderTileBody", this).call(this);
            }
          }, {
            key: "renderTileFooter",
            value: function renderTileFooter() {
              if (this.customCard) return null;
              return babelHelpers.get(babelHelpers.getPrototypeOf(CustomCard.prototype), "renderTileFooter", this).call(this);
            }
          }]);
          return CustomCard;
        }(require("card/".concat(type)).default), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "customCard", [_decorators.prop], {
          configurable: true,
          enumerable: true,
          writable: true,
          initializer: null
        }), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "customCardBody", [_decorators.prop], {
          configurable: true,
          enumerable: true,
          writable: true,
          initializer: null
        })), _class3);
      }

      return this.SubTypes[type];
    }
  }]);
  return CustomCatalogCard;
}(_base.default), _class2.SubTypes = {}, _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "card_type", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = CustomCatalogCard;